import { useEffect } from "react";

/* eslint-disable import/no-anonymous-default-export */
export default (loginFormVisibility: boolean, callback) => {
	useEffect(() => {
		if (loginFormVisibility) {
			const google = (window as any).google;
			if (google) {
				const googleWrapper = document.getElementById("googleBtn");
				google.accounts.id.initialize({
					client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID!,
					callback: callback,
				});
				google.accounts.id.renderButton(googleWrapper, {
					type: "primary",
					shape: "pill",
				});
			}
		}
	}, [loginFormVisibility]);
}